module.exports = __webpack_public_path__ + "static/media/area-posting.f2502c59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/area-posting.svg
// module id = 1247
// module chunks = 1